import { CoatingTypeEnum } from 'src/enums/stowage/coatingTypeEnum';
import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const ibc15_11_3SoftRule = {
    id: StowageRuleId.Ibc15_11_3SoftRule,
    name: 'IBC 15.11.3 Toxic products can only be stowed in Stainless Steel tanks.',
    lastUpdatedUtc: '2014-10-07T13:24:00',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                operator: BooleanOperator.OR,
                children: [
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category specific and operational requirements',
                                    fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'IBC chapter 15.11',
                                    type: 'string',
                                    referenceValue: 'IBC-15.11',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Contains,
                        },
                    },
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category specific and operational requirements',
                                    fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'IBC chapter 15.11.3',
                                    type: 'string',
                                    referenceValue: 'IBC-15.11.3',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Contains,
                        },
                    },
                ],
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank coating',
                            fieldPath: 'tank.coating.type',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: CoatingTypeEnum.StainlessSteel,
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsNotEqualTo,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content weight',
                            fieldPath: 'getStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'IBC 15.11 Check Certificate of Fitness before stowing.',
    },
} as StowageRuleBM;
